import React, { useMemo, useCallback, Suspense, lazy } from "react";
import "../../css/login.css";
import logo from "../../Assets/seoimg/logo.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  INVITE_AUTH,
  POST_MAILFORNEWUSER_REGISTER,
  regester_consent,
  regester_withAPi,
  regester_withOTP,
  INVITE_LIMIT_CHECK,
  POST_ADDON,
} from "../../../services/constants";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import GetCustomer from "../../../confrigration/getCustomer";
import { ReCaptcha } from "../../share/components/googleRecaptacha";
import Footer from "../../share/footer";
import "./login.scss";
import closeEyeIcon from "../../Assets/common/close-eye.svg";
import openEyeIcon from "../../Assets/common/open-eye.svg";
import { validatePassword } from "../../../helperJs/helper";
import useIpAddress from "../../../helperJs/useIpAddress";
import countryList from "../../dataFiles/country";
import Dropdown from "../../share/components/dropdown";
import Spinner from "../../share/components/spinner";
import { useTranslation } from "react-i18next";
import AddProjectStore from "../../../store/AddProjectStore";
import { TextField } from "@mui/material";
import Loginslider from "./loginSlider";

const SocialJuice = lazy(() => import("../../share/components/SocialJuice"));

const Register = () => {
  // navigator
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const ipAddress = useIpAddress();
  const location = useLocation();
  const { pathname } = location;
  // state vaiables
  const [name, setName] = useState("");
  const [lastname, setLastName] = useState("");
  const [company, setCompany] = useState("");
  const [password2, setPassword2] = useState("");
  const [email, setEmail] = useState("");
  const [SpecialCharError, setSpecialCharError] = useState(false);
  const [password, setPassword] = useState("");
  const [OTP, setOTP] = useState(false);
  const [OTPVail, setOtpVail] = useState(0);
  const [byorganization, setByOrganization] = useState(false);
  const [main_user_mail, setMain_user_mail] = useState(null);
  const [PassSecure, setPassSecure] = useState(false);
  const [PassSecure2, setPassSecure2] = useState(false);
  const [consent, setConsent] = useState(false);
  const [minLengthError, setMinLengthError] = useState(false);
  const [country, setCountry] = useState({
    name: "United States",
    value: 2840,
    flag: "https://flagsapi.com/US/flat/24.png",
  });

  const domain = window.location.hostname; // 💡 Not in `location`
  const { appliedWhiteLable } = AddProjectStore((state) => state);

  const country_data = useMemo(() => {
    return countryList?.map((country) => {
      return {
        location_code: country.location_code,
        location_name: country.location_name,
        location_flag: country.location_flag,
      };
    });
  }, [countryList]);

  const [Count, setCount] = useState(0);
  const [CountValid, setCountValid] = useState(30);
  const [isDisable, setisDisable] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const invite_code = queryParams.get("l");
    if (invite_code) {
      sessionStorage.setItem("invite-code", invite_code);
      queryParams.delete("l");
      navigate(
        {
          pathname: location.pathname,
          search: queryParams.toString(),
        },
        { replace: true }
      );
    }
  }, [location, navigate]);

  // validation alerts
  const [mydata, setMydata] = useState(false);
  //invite by organization handler
  const urlSearchParams = new URLSearchParams(window.location.search);
  const main_userMail = urlSearchParams.get("email");
  const user_aff_id = urlSearchParams.get("aff_id");

  const fatch_InviteAuth = () => {
    axios.get(INVITE_AUTH(main_userMail)).then((res) => {
      dispatch({ type: "SUBUSERINVITELENGTH", payload: res.data });
      dispatch({ type: "NOTLOADING" });
    });
  };

  const postAddonLimits = () => {
    axios
      .post(POST_ADDON(), {
        email: email,
        project: 0,
        track_key: 0,
        dom_over: 0,
        site_audit: 0,
        key_res: 0,
        backlinks: 0,
        pdf: "false",
        backlink_domain: 0,
        sub_invite: 0,
        competitor: 0,
        crawl_domain: 0,
        ai: 0,
        meta: 0,
        ai_word: 0,
        ref_domain: 0,
        map_track: false,
        exact_url: 0,
      })
      .then(() => {})
      .catch(() => console.log("addon limit failed"));
  };

  useEffect(() => {
    if (main_userMail) {
      fatch_InviteAuth();
      setByOrganization(true);
      const lowercaseEmail = main_userMail.toLowerCase();
      setMain_user_mail(lowercaseEmail);
    }
  }, [main_userMail]);

  const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;

  useEffect(() => {
    const MIN_LENGTH = 3;
    setSpecialCharError(hasSpecialChars.test(name));
    setMinLengthError(name.length > 0 && name.length < MIN_LENGTH);
  }, [name]);

  const user_consent = () => {
    const consent = {
      email: email,
      consent: "Yes",
    };
    axios
      .post(regester_consent(), consent)
      .then((response) => {})
      .catch((error) => {});
  };

  const registerHandler = (e) => {
    e.preventDefault();
    if (email === "" || password === "" || password2 === "" || name === "") {
      setMydata(t("auth.register.required_validation"));
      return;
    }
    const passwordError = validatePassword(password);
    if (passwordError) {
      setMydata(validatePassword(password));
      return;
    }

    const items = {
      email: email,
      first_name: name,
      last_name: "",
      subscription: "",
      address: ipAddress,
    };

    const config = {
      method: "post",
      url: "https://app.rankspro.io/api/user/mailchimp/",
      maxBodyLength: Infinity,
      data: items,
    };

    if (password.length > 32) {
      setMydata(t("auth.register.form.password.validation.is_to_long"));
    } else if (password !== password2) {
      setMydata(t("auth.register.form.confirm_password.validation.not_match"));
    } // Individual User
    else if (OTP !== false && byorganization === false) {
      if (Number(OTPVail) === OTP) {
        setMydata(false);
        let item = {
          user_type: "individual",
          main_user_mail: email,
          email: email,
          name: name,
          last_name: lastname === "" ? "0" : lastname,
          company_name: company === "" ? "0" : company,
          country: country.name,
          password: password,
          password2: password2,
          tc: "True",
          affiliate_id: user_aff_id || "0",
        };

        axios
          .post(regester_withAPi(), item)
          .then(async (res) => {
            setOTP(false);
            setMydata(false);
            user_consent();

            AddProjectStore.setState({
              user_answer: {
                open: true,
                email,
              },
            });

            axios
              .get("https://api64.ipify.org/")
              .then((response) => {
                const newuserregister = {
                  email: email,
                  name: name,
                  Ip: response.data,
                };
                postAddonLimits();
                // for sending mail for admin
                axios.post(POST_MAILFORNEWUSER_REGISTER(), newuserregister);
              })
              .catch(() => {
                const newuserregister = {
                  email: email,
                  name: name,
                  Ip: "No Ip Found",
                };
                // for sending mail for admin
                axios.post(POST_MAILFORNEWUSER_REGISTER(), newuserregister);
              });

            axios.request(config).catch((error) => console.log(error));
            navigate("/onboarding");
          })
          .catch((res) => {
            setMydata(t("auth.register.form.email.validation.already_exist"));
          });
      } else {
        setMydata(t("auth.register.otp_verify.form.otp.validation.not_match"));
      }
    } // Organization User
    else if (OTP !== false && byorganization === true) {
      if (Number(OTPVail) === OTP) {
        setMydata(false);
        let item = {
          user_type: "organization",
          main_user_mail: main_user_mail,
          email: email,
          password: password,
          password2: password2,
          name: name,
          last_name: lastname === "" ? "0" : lastname,
          company_name: company === "" ? "0" : company,
          country: country.name,
          tc: "True",
          affiliate_id: user_aff_id || "0",
        };

        axios
          .post(regester_withAPi(), item)
          .then(async (res) => {
            setOTP(false);
            setMydata(false);
            user_consent();

            AddProjectStore.setState({
              user_answer: {
                open: true,
                email,
              },
            });

            axios.request(config).catch((error) => console.log(error));

            axios
              .get("https://api64.ipify.org/")
              .then((response) => {
                const newuserregister = {
                  email: email,
                  name: name,
                  Ip: response.data,
                };
                postAddonLimits();
                // for sending mail for admin
                axios.post(POST_MAILFORNEWUSER_REGISTER(), newuserregister);
              })
              .catch(() => {
                const newuserregister = {
                  email: email,
                  name: name,
                  Ip: "No Ip Found",
                };
                // for sending mail for admin
                axios.post(POST_MAILFORNEWUSER_REGISTER(), newuserregister);
              });

            navigate("/onboarding");
          })
          .catch((error) => {
            setMydata(t("auth.register.form.email.validation.already_exist"));
          });
      } else {
        setMydata(t("auth.register.otp_verify.form.otp.validation.not_match"));
      }
    } else {
      const limit = sessionStorage.getItem("invite-code");
      let item = {
        email: email,
      };

      if (pathname === "/register") {
        setOTP(true);
        setisDisable(true);
        axios.post(regester_withOTP(), item).then((res) => {
          setOTP(res.data.otp);
          setCount(30);
        });
      } else if (limit != null) {
        axios
          .get(INVITE_LIMIT_CHECK(email, limit))
          .then((response) => {
            if (response.data.msg === "True") {
              sessionStorage.removeItem("invite-code");
              setOTP(true);
              setisDisable(true);
              axios.post(regester_withOTP(), item).then((res) => {
                setOTP(res.data.otp);
                setCount(30);
              });
            } else {
              setMydata(t("auth.register.invite_limit_validation"));
            }
          })
          .catch(() => {
            setMydata(t("auth.register.something_went_wrong_validation"));
          });
      } else {
        setMydata(t("auth.register.something_went_wrong_validation"));
      }
    }
  };

  const VERIFY = () => {
    setOTP(true);
    let item = {
      email: email,
    };
    axios.post(regester_withOTP(), item).then((res) => {
      setOTP(res.data.otp);
    });
  };

  const HandleResend = () => {
    VERIFY();
    setisDisable(true);
    setCount(30);
  };

  useEffect(() => {
    let interval;
    if (Count > 0) {
      interval = setInterval(() => {
        setCount((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setisDisable(false);
    }

    return () => clearInterval(interval);
  }, [Count]);

  useEffect(() => {
    let interval;
    if (CountValid > 0) {
      interval = setInterval(() => {
        setCountValid((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [CountValid]);

  // dropdownhandler
  const countryDetailHandler = (res) => {
    setCountry({
      name: res.location_name,
      value: res.location_code,
      flag: res.location_flag,
    });
  };

  const handleFirstNameChange = useCallback((e) => {
    const value = e.target.value;
    if (!value.includes(" ")) {
      setName(value);
    }
  }, []);

  const handleLastNameChange = useCallback((e) => {
    const value = e.target.value;
    if (!value.includes(" ")) {
      setLastName(value);
    }
  }, []);

  return (
    <>
      {main_user_mail ? <GetCustomer email={main_user_mail} /> : false}
      <div className="loginBox acc-container">
        <div className="left-side">
          <div className="left-side-container">
            <>
              <img
                className="brand-logo"
                key={appliedWhiteLable.header_logo || logo}
                src={appliedWhiteLable.header_logo || logo}
                alt="login img"
              />
              {domain === "app.rankspro.io" || domain === "localhost" ? (
                <div
                  className=""
                  style={{
                    width: "95%",
                    height: "75%",
                    overflowY: "auto",
                    marginBottom: "30px",
                  }}
                >
                  <Suspense fallback={<Spinner />}>
                    <SocialJuice id="de54d170-815e-461f-b737-fd181d55415c" />
                  </Suspense>
                </div>
              ) : (
                <Loginslider />
              )}
            </>
          </div>
        </div>
        <div className="right-side">
          <div className="loginRight">
            <img
              className="brand-logo Loginlogo"
              key={appliedWhiteLable.header_logo || logo}
              src={appliedWhiteLable.header_logo || logo}
              alt="login img"
            />
            {domain === "app.rankspro.io" || domain === "localhost" ? (
              <div
                style={{ width: "100%", maxWidth: "78%" }}
                className="social-juice"
              >
                <Suspense fallback={<Spinner />}>
                  <SocialJuice id="e9499166-1c27-4903-ab39-9210750013c7" />
                </Suspense>
              </div>
            ) : null}
            <div className="FormBox RegisterForm">
              <h1
                style={{ fontSize: "40px", fontWeight: "700" }}
                className="text-left mt-4 mb-1 "
              >
                {OTP
                  ? t("auth.register.otp_verify.title")
                  : t("auth.register.title")}
              </h1>
              <p style={{ fontSize: "16px", fontWeight: "400" }}>
                Sign up and start quickly! Create an account, explore features,
                and access tools in minutes.
              </p>
              <form onChange={() => setMydata(false)}>
                <div className="">
                  {OTP ? (
                    <div className="optic-scroll">
                      <p className="mb-1" style={{ color: "#828282" }}>
                        {t("auth.register.otp_verify.description")}
                      </p>
                      <input
                        type="number"
                        placeholder={t("auth.register.otp_verify.form.otp")}
                        onChange={(e) => setOtpVail(e.target.value)}
                      ></input>
                      <div className="resend-otp">
                        <p className="vl-msd-line-login">{mydata} </p>
                        <div className="otp">
                          <button
                            onClick={HandleResend}
                            disabled={isDisable || CountValid > 1}
                            style={{
                              opacity: isDisable || CountValid > 1 ? 0.5 : 1,
                            }}
                          >
                            {t("auth.register.otp_verify.resend_code")}
                          </button>
                          {isDisable && (
                            <p className="mb-0">{`(${Count} sec)`}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="RegisterInputBox">
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-6">
                          <div>
                            <TextField
                              type="text"
                              name="name"
                              className="textfield"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "10px",
                                },
                              }}
                              label={t(
                                "auth.register.form.first_name.placeholder"
                              )}
                              value={name}
                              onChange={handleFirstNameChange}
                            />
                          </div>
                          {/* <div className="col-12 col-md-6 col-lg-12"> */}
                          {SpecialCharError && (
                            <span className="specialError">
                              {t(
                                "auth.register.form.email.validation.special_characters_not_allowed"
                              )}
                            </span>
                          )}
                          {minLengthError && (
                            <span className="specialError">
                              {t(
                                "auth.register.form.name.validation.min_length"
                              )}
                            </span>
                          )}
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                          <TextField
                            type="text"
                            name="name"
                            className="textfield"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                              },
                            }}
                            label={t(
                              "auth.register.form.last_name.placeholder"
                            )}
                            value={lastname}
                            onChange={handleLastNameChange}
                          />
                        </div>
                      </div>

                      <TextField
                        type="email"
                        name="email"
                        className="textfield"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                        }}
                        label={t("auth.register.form.email.placeholder")}
                        onChange={(e) => setEmail(e.target.value.toLowerCase())}
                      />

                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-6">
                          <TextField
                            type="text"
                            name="name"
                            className="textfield"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                              },
                            }}
                            label={t("auth.register.form.company.placeholder")}
                            onChange={(e) => {
                              setCompany(e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                          <Dropdown
                            img={country.flag}
                            data={country_data}
                            title={country.name}
                            className="textfield"
                            style={{
                              textTransform: "none",
                              boxShadow: "none",
                              border: "1px solid rgba(0, 0, 0, 0.5019607843)",
                              padding: "0.65rem",
                              height: "56px",
                              width: "100%",
                              borderRadius: "10px",
                            }}
                            callback={countryDetailHandler}
                          />
                        </div>
                      </div>

                      <div className="row  ">
                        <div className="col-12 col-md-6 col-lg-6">
                          <div className="password-type">
                            <TextField
                              name="password"
                              className="textfield"
                              type={PassSecure ? "text" : "password"}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "10px",
                                },
                              }}
                              label={t(
                                "auth.register.form.password.placeholder"
                              )}
                              placeholder={t(
                                "auth.register.form.password.placeholder"
                              )}
                              onChange={(e) => setPassword(e.target.value)}
                              autoComplete="false"
                            />
                            {PassSecure ? (
                              <img
                                src={closeEyeIcon}
                                alt=""
                                onClick={() => setPassSecure(false)}
                              />
                            ) : (
                              <img
                                src={openEyeIcon}
                                alt=""
                                onClick={() => setPassSecure(true)}
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                          <div className="password-type">
                            <TextField
                              name="confirm-password"
                              className="textfield"
                              type={PassSecure2 ? "text" : "password"}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "10px",
                                },
                              }}
                              label={t(
                                "auth.register.form.confirm_password.placeholder"
                              )}
                              onChange={(e) => setPassword2(e.target.value)}
                              autoComplete="false"
                            />
                            {PassSecure2 ? (
                              <img
                                src={closeEyeIcon}
                                alt=""
                                onClick={() => setPassSecure2(false)}
                              />
                            ) : (
                              <img
                                src={openEyeIcon}
                                alt=""
                                onClick={() => setPassSecure2(true)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      {/* <ul
                          className="mt-1"
                          style={{
                            paddingLeft: "5px",
                            opacity: ".5",
                            fontSize: "13px",
                          }}
                        >
                          <li>{t("auth.register.password_description")}</li>
                        </ul> */}

                      <div className="consent-register">
                        <input
                          type="checkbox"
                          value={consent}
                          name="consent"
                          onChange={() => setConsent((pre) => !pre)}
                        />
                        <p className="mb-0 ms-2" htmlFor="consent">
                          {t("auth.register.i_agree")}{" "}
                          <a
                            href="https://www.rankspro.io/privacy"
                            target="_blank"
                          >
                            {t("auth.register.privacy_policy")}
                          </a>
                          ,{" "}
                          <a
                            href="https://www.rankspro.io/terms"
                            target="_blank"
                          >
                            {t("auth.register.terms_and_conditions")}
                          </a>
                          ,{" "}
                          <a
                            href="https://www.rankspro.io/refund-policy"
                            target="_blank"
                          >
                            {t("auth.register.refund_policy")}
                          </a>
                          {t("auth.register.other_terms")}
                        </p>
                      </div>
                      <p className="vl-msd-line-login mb-0">
                        {mydata ? mydata : false}{" "}
                      </p>
                    </div>
                  )}
                  {/* </div> */}

                  <div>
                    <button
                      type="submit"
                      className="login_btn  w-100 ResgisterSubmit"
                      onClick={registerHandler}
                      disabled={!OTP && !consent}
                    >
                      {OTP
                        ? t("auth.register.otp_verify.verify_now")
                        : t("auth.register.submit")}
                    </button>
                    <h6 className="rs-now lastLine">
                      {t("auth.already_have_an_account")}
                      <Link
                        to="/login"
                        className=""
                        style={{ color: "#6254ff" }}
                      >
                        {" "}
                        {t("auth.login_now")}{" "}
                      </Link>
                    </h6>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ReCaptcha />
    </>
  );
};

export default Register;
